<template>
  <div v-if="files">
    <b-list-group>
      <b-list-group-item
          class="flex-column align-items-start"
          v-for="file in files"
          :key="file.id"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ file.id }}: {{ file.name }}</h5>
          <div>
            <b-button
                @click="showEditFile(file)"
                variant="outline-primary"
                style="margin-right: 10px;"
            >
              Bearbeiten
            </b-button>
            <b-button variant="outline-danger" @click="deleteFile(file)">X</b-button>
          </div>
        </div>

        <p class="mb-1">
          {{ file.description }}
        </p>
      </b-list-group-item>
    </b-list-group>
    <p style="padding-top: 10px;">Hinzufügen:</p>
    <b-input-group class="mt-3">
      <b-form-file
          browse-text="Auswählen"
          multiple
          v-model="input"
          placeholder="Datei auswählen oder hinein ziehen"
      />
      <b-input-group-append>
        <b-button variant="outline-success" @click="uploadFiles">Hochladen</b-button>
      </b-input-group-append>
    </b-input-group>
    <b-modal id="editFile">
      <b>Name:</b>
      <b-input v-model="currentFile.name"></b-input>
      <b>Beschreibung:</b>
      <b-textarea v-model="currentFile.description"/>

      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="warning" @click="cancel()" class="text-white">
          Verwerfen
        </b-button>
        <b-button size="sm" variant="success" @click="saveImageDescription()">
          Speichern
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import helpers from "@/helpers";
import {mapActions} from "vuex";

export default {
  name: "Files",
  props: {
    files: Array,
  },
  data() {
    return {
      currentFile: {},
      input: null
    }
  },
  methods: {
    ...mapActions([
      'uploadFile',
    ]),
    showEditFile(file) {
      this.currentFile = this.getCurrentFileDecoupledCopy(file)
      this.$bvModal.show('editFile')
    },
    getCurrentFileDecoupledCopy(file) {
      return JSON.parse(JSON.stringify(file));
    },
    saveImageDescription() {
      this.$bvModal.hide('editFile')
      let originalFile = this.files.find(element => element.id === this.currentFile.id)
      originalFile.description = this.currentFile.description
      originalFile.name = this.currentFile.name
    },
    uploadFiles() {
      if (!this.input) return helpers.handleWarningMessage("Bitte wählen Sie mindestens eine Datei aus.")
      for (const file of this.input) {
        this.uploadFile(file).then(response => {
          this.pushFileToArray(file, response)
        })
      }
    },
    pushFileToArray(file, response) {
      this.files.push({
        name: file.name,
        description: "",
        url: process.env.VUE_APP_API_URL + response.data,
        id: this.getMaxIdImages() + 1
      })
    },
    getMaxIdImages() {
      if (this.files.length === 0) {
        return 1
      }

      return Math.max.apply(Math, this.files.map(function (file) {
        return file.id;
      }))
    },
    deleteFile(file) {
      const index = this.files.indexOf(file);
      if (index !== -1) this.files.splice(index, 1);
    }
  },
  computed: {
  }
}
</script>
